import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { forgotPassword } from '../../redux/actions/authActions'
import { Link, useNavigate } from 'react-router-dom'
import styles from '../../sass/signin.module.scss'
import { IMG } from '../../constant'
import { toast } from 'react-toastify'

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loader } = useSelector((state) => state.user);
  const [error, setError] = useState(null);

  const handleForgotPassword = () => {
    const data = { email };

    dispatch(forgotPassword(data))
      .unwrap()
      .then((response) => {
        toast.success('A password reset link has been sent to your email.');
        const { token, email } = response;
        navigate(`/reset-password?token=${token}&email=${email}`);
      })
      .catch((error) => {
        if (error.errors && typeof error.errors === 'object') {
          const errorMessages = Object.values(error.errors).flat(); // Convert errors object to an array of messages
          setError(errorMessages);
        } else {
            setError(error.message || 'Failed to reset password. Please try again.');
        }
      });
  };

  return (
    <div className={styles.AuthSectionContainer}>
      <div className={styles.AuthSectionContainer_body} style={{ backgroundImage: `url(${IMG.authblur})` }}>
        <img src={IMG.logo} className={styles.AuthSectionContainer_logo} alt='logo' />
        <h1 className={styles.AuthSectionContainer_title}>Forgot your password?</h1>
        <p className={styles.AuthSectionContainer_subtitle}>Enter your email or phone number, and we’ll <br />help you reset your password.</p>

        <input
          type="email"
          placeholder="Enter your email address"
          className={styles.AuthSectionContainer_form_input}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
       
        {loader ? (
          <button
            className={styles.ActionButton_fill}
            disabled
          >
            Please wait...
          </button>
        ) : (
          <button
            onClick={handleForgotPassword}
            className={styles.ActionButton_fill}
          >
            Send Reset Link
          </button>
        )}

        {error && (
        <div className={styles.AuthSectionContainer_errors}>
            {Array.isArray(error)
            ? error.map((errMsg, index) => <div key={index}>{errMsg}</div>)
            : error}
        </div>
        )}

        <div className={styles.AuthSectionContainer_footer}>
          {/* <span className="">Back to Login</span> */}
          <Link to='/login' className={styles.AuthSectionContainer_link}>↩&nbsp;&nbsp;Back to Login</Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
